import { Popconfirm as AntdConfirm } from 'antd';
import React from 'react';

export const Confirm = ({ ...rest }) => {
    return <AntdConfirm okText={'Да'} cancelText={'Нет'} {...rest} />;
};
